<template>
    <div class="message" :class="{ sent: isSent }">
        <div class="img-content">
            <img class="img" :src="avatar" :key="avatar">
        </div>

        <span class="name">{{ username }}</span>

        <span class="date">{{ createdAt }}</span>

        <p class="text" v-html="message.message" v-if="message.message"></p>
        <a class="text file" :href="message.fileUrl" target="_blank" :download="message.file" v-else>
            <IconComponent icon="file" class="icon"></IconComponent>
            <span>{{ message.file }}</span>
        </a>
    </div>
</template>

<script>
import IconComponent from "@/components/Icons.vue";
import moment from 'moment';

export default {
    name: 'ChatMessage',
    props: {
        message: { required: true },
    },
    components: {
        IconComponent,
    },
    data() {
        return {
            liveTime: this.getFormattedTime(),
            intervalId: null,
        };
    },
    methods: {
        getFormattedTime() {
            if (!this.message.createdAt) {
                return "Agora mesmo"
            }

            moment.locale("pt")
            return moment(this.message.createdAt.toDate()).fromNow()
        },
    },
    computed: {
        currentUser() {
            return this.$store.state.users.currentUser
        },
        avatar() {
            if (this.profile == null) {
                return null
            }
            return this.profile.avatarUrl
        },
        createdAt() {
            return this.liveTime;
        },
        username() {
            if (this.profile == null) {
                return "..."
            }
            return this.profile.name
        },
        profile() {
            return this.$store.getters['profiles/id'](this.message.user)
        },
        isSent() {
            return this.message.user == this.currentUser.uid
        }
    },

    watch: {
        profile: {
            immediate: true,
            handler() {
                if (this.profile == null) {
                    this.$store.dispatch('profiles/get', this.message.user)
                }
            },
        },
    },
    mounted() {
        this.intervalId = setInterval(() => {
            this.liveTime = this.getFormattedTime()
        }, 60000)
    },
    beforeUnmount() {
        clearInterval(this.intervalId)
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.message {
    display: grid;
    grid-template-columns: min-content min-content 1fr;
    gap: .5rem .5rem;
    grid-template-rows: 60px 1fr;
    grid-template-areas:
    "icon name date"
    "message message message";
    padding: 0.25rem 1rem 1.5rem;
    text-align: start;
    transition: background-color .05s;
    border-radius: 10px;
    margin: 1em 0;
    background-color: var(--bg-color-2);
    color: var(--text-color);     
    
    &.sent {
        max-width: 90%;
        width: fit-content;
        background-color: var(--bg-color-3);
        grid-template-columns: 1fr min-content min-content;
        margin-left: auto;
        grid-template-areas:
            "date name icon"
            "message message message";

        .date {
            margin: auto 0 auto auto;
        }
    }

    .img-content {
        grid-area: icon;
        height: 60px;
        width: 60px;
        object-fit: contain;
        display: inline-block;
        margin: 0;
        border-radius: 50%;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            border: 3px solid rgba(var(--black), 1);
            padding: .3em;
            object-fit: contain;
        }
    }

    .name {
        grid-area: name;
        margin: auto;
        font-weight: bold;
    }

    .date {
        grid-area: date;
        margin: auto auto auto 0;
        opacity: .65;
        font-size: .75rem;
    }

    .text {
        grid-area: message;
        margin: 0;

        :deep(a) {
            color: var(--highlight-color);
        }
    }

    .file {
        display: flex;
        align-items: center;
        gap: 1rem;
        cursor: pointer;
        width: fit-content;
        --icon-color: var(--text-color);
        white-space: nowrap;
    }

    .icon {
        width: 30px;
        height: 30px;
    }
}
</style>
